import { render } from "./homepage-2026.html?vue&type=template&id=636f7ae1"
import script from "./homepage-2026.js?vue&type=script&lang=js"
export * from "./homepage-2026.js?vue&type=script&lang=js"

import "./homepage-2026.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/vito.degioia/Documents/Projects/mb-fiori-2023/fiori-del-mulino/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__